import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { style as buttonIconPlaceholderStyle } from "./ButtonIconPlaceholder.style";

const ButtonIconPlaceholder: FC = () => {
  const style = useMemo(() => buttonIconPlaceholderStyle(), []);

  return <View style={style.buttonIconPlaceholder} />;
};

export { ButtonIconPlaceholder };
